import React from 'react';
import MailIcon from '../SVG/MailIcon';
import TwitterIcon from '../SVG/TwitterIcon';
import FacebookIcon from '../SVG/FacebookIcon';
import RedditIcon from '../SVG/RedditIcon';
import YouTubeIcon from '../SVG/YouTubeIcon';
import { EMAIL, TWITTER, REDDIT, YOUTUBE, FACEBOOK } from '../const';

const ContactButton = ({ size, service, url, solid, style }) => {
  const icon = () => {
    switch (service) {
      case EMAIL:
        return <MailIcon width={size} />;
      case TWITTER:
        return <TwitterIcon width={size} />;
      case FACEBOOK:
        return <FacebookIcon width={size} />;
      case REDDIT:
        return <RedditIcon width={size} />;
      case YOUTUBE:
        return <YouTubeIcon width={size} solid={solid} color={(style || {}).color || 'white'} />;
      default:
    }
  };

  return (
    <div className="home-contact-item" style={{ ...style, height: `${size}px` }}>
      <a href={url || service} target="_blank" rel="noopener noreferrer">
        {icon()}
      </a>
    </div>
  );
};

export default ContactButton;
